import {PropsWithChildren} from 'react';
import {PointTooltipProps} from '@nivo/line';
import {BarTooltipProps, BarDatum} from '@nivo/bar';
import moment from 'moment';
import {IChartData} from './compareChart';

const ToolTip = ({
  point,
  data,
  bar,
}: {
  point?: PropsWithChildren<PointTooltipProps>;
  data: IChartData[];
  bar?: PropsWithChildren<BarTooltipProps<BarDatum>>;
}) => {
  if (point) {
    const p = point?.point;
    const unit: string = data.find((d) => d.id === p?.serieId)?.unit ?? '';
    const chemicaldata: string = p?.data?.yFormatted.toString() ?? '';
    const formattedTime: string = moment(p?.data?.xFormatted).format(
        'YYYY-MM-DD HH:mm',
    );

    return (
      <div className="tool-tip-container" style={{zIndex: 10000000000}}>
        <div className="tool-tip-time">{formattedTime}</div>
        <div className="tool-tip-value">
          {chemicaldata} {unit}
        </div>
      </div>
    );
  }

  return <div />;
};

export default ToolTip;
